var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nio-header-nav',{attrs:{"position":"fixed","leftButton":"close","is-white":true},on:{"back":_vm.handleBack}}),_c('div',{attrs:{"id":"purchaseAgreement"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }